// extracted by mini-css-extract-plugin
export default {"field":"UserAddPopup_field__5bWR-","text":"UserAddPopup_text__Jq2BE"};